import React, { useState } from 'react';
import PurchaseOrderList from './PurchaseOrderList';
import PurchaseOrderCreate from './PurchaseOrderCreate';
import PurchaseOrderDetail from './PurchaseOrderDetail';
import SuppliersManager from './SuppliersManager';
import TPLModule from '../Operations/TPLModule';
import { FileText, Building2, Warehouse } from 'lucide-react';

const PurchaseOrdersManager = () => {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'create', 'detail', 'suppliers'
  const [selectedPOId, setSelectedPOId] = useState(null);
  const [activeTab, setActiveTab] = useState('orders'); // 'orders', 'suppliers', '3pl'
  
  // Get tenant ID from localStorage (same pattern as other components)
  const tenantId = localStorage.getItem('tenant_id') || 'tenant-123';

  const handleNavigate = (view, poId = null) => {
    setCurrentView(view);
    setSelectedPOId(poId);
  };

  // Tab navigation
  const tabs = [
    { id: 'orders', label: 'Purchase Orders', icon: FileText },
    { id: 'suppliers', label: 'Suppliers', icon: Building2 },
    { id: '3pl', label: '3PL & Operations', icon: Warehouse },
  ];

  // Render Suppliers tab
  if (activeTab === 'suppliers') {
    return (
      <div className="min-h-screen bg-[#0f1729]">
        {/* Tab Navigation */}
        <div className="bg-[#1a2744] border-b border-gray-700 px-3 pt-2">
          <div className="flex gap-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => { setActiveTab(tab.id); setCurrentView('list'); }}
                className={`flex items-center gap-1.5 px-3 py-2 text-xs font-medium rounded-t transition-colors ${
                  activeTab === tab.id
                    ? 'bg-[#0f1729] text-white border-t border-l border-r border-gray-700'
                    : 'text-gray-400 hover:text-white hover:bg-[#243352]'
                }`}
              >
                <tab.icon className="w-3.5 h-3.5" />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <SuppliersManager />
      </div>
    );
  }

  // Render 3PL & Operations tab
  if (activeTab === '3pl') {
    return (
      <div className="min-h-screen bg-[#0f1729]">
        {/* Tab Navigation */}
        <div className="bg-[#1a2744] border-b border-gray-700 px-3 pt-2">
          <div className="flex gap-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => { setActiveTab(tab.id); setCurrentView('list'); }}
                className={`flex items-center gap-1.5 px-3 py-2 text-xs font-medium rounded-t transition-colors ${
                  activeTab === tab.id
                    ? 'bg-[#0f1729] text-white border-t border-l border-r border-gray-700'
                    : 'text-gray-400 hover:text-white hover:bg-[#243352]'
                }`}
              >
                <tab.icon className="w-3.5 h-3.5" />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <TPLModule tenantId={tenantId} />
      </div>
    );
  }

  // Render based on current view (Purchase Orders tab)
  const renderContent = () => {
    if (currentView === 'create') {
      return <PurchaseOrderCreate onNavigate={handleNavigate} />;
    }

    if (currentView === 'detail' && selectedPOId) {
      return <PurchaseOrderDetail poId={selectedPOId} onNavigate={handleNavigate} />;
    }

    return <PurchaseOrderList onNavigate={handleNavigate} />;
  };

  return (
    <div className="min-h-screen bg-[#0f1729]">
      {/* Tab Navigation - Only show on list view */}
      {currentView === 'list' && (
        <div className="bg-[#1a2744] border-b border-gray-700 px-3 pt-2">
          <div className="flex gap-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => { setActiveTab(tab.id); setCurrentView('list'); }}
                className={`flex items-center gap-1.5 px-3 py-2 text-xs font-medium rounded-t transition-colors ${
                  activeTab === tab.id
                    ? 'bg-[#0f1729] text-white border-t border-l border-r border-gray-700'
                    : 'text-gray-400 hover:text-white hover:bg-[#243352]'
                }`}
              >
                <tab.icon className="w-3.5 h-3.5" />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      )}
      {renderContent()}
    </div>
  );
};

export default PurchaseOrdersManager;

